export default class Header{
	constructor(){
		const header = document.querySelector(".header");
		const header_container = document.querySelector(".header__container");
		const toggleBtn = document.querySelector(".header__btn");
		const headerHeight = 94;
		let isHidden = false;

		if(window.currentContext=="pc"){
			const headerScrollHandler = (scrollTop)=>{
				const rpxRatio = window.vw / (window.currentContext=="pc" ? 1440 : 375);
				const offset = Math.min(headerHeight*rpxRatio, Math.max(0, scrollTop))*-1;
				header_container.style.transform = "translateY("+offset+"px)";
				if( (headerHeight*rpxRatio < scrollTop) != isHidden ){
					isHidden = (headerHeight*rpxRatio < scrollTop);
					if(isHidden){
						header.classList.add("hidden");
					}else{
						header.classList.remove("hidden");
					}
				}
			}
			window.globalScroller.appendScrollHandler(headerScrollHandler);
			headerScrollHandler();

			toggleBtn.addEventListener("mouseenter", ()=>{
				header.classList.add("open");
				header.classList.add("toggle");
			});
			header.addEventListener("mouseleave", ()=>{
				if(!document.documentElement.classList.contains("transit-ready")){
					header.classList.remove("open");
				}
			});
		}else{
			let isOpen = false;
			toggleBtn.addEventListener("click", ()=>{
				if(isOpen){
					header.classList.remove("open");
					isOpen = false;
				}else{
					header.classList.add("open");
					isOpen = true;
				}
			});
		}
	}
}